import i18next from 'i18next';

export const handleImgError = (e) => {
  switch (i18next.language) {
    case 'ja':
      e.target.src = '/img/error_ja.png';
      break;
    default:
      e.target.src = '/img/error_ko.png';
  }
};
